const $td = $("#td");
let $ttgInlineListMapWrapper = $('<div />').addClass('ttgInlineListMapWrapper'),
    $ttgInlineListSelectedMapItem = $('<div />').prop('id', 'ttgInlineListSelectedMapItem'),
    $ttgFullScreenInfoDiv = $('<div />').prop('id', 'ttgFullScreenSelectedMapItem');

/* SET ENVIRONMENT WHEN LIST IS LOADED */
$td.arrive("#metaQueryUrl", function(metaQuery) {

    if (Done.Maps.isSupported()) {

        let $metaQueryUrl = new URL($.trim($(metaQuery).text()).replace(/&amp;/g, "&"));

        /* META PARAMS */
        _ttgMaps.metaParams.experience = $metaQueryUrl.searchParams.get('experience');
        _ttgMaps.metaParams.type = $metaQueryUrl.searchParams.get('type');
        _ttgMaps.metaParams.q = $metaQueryUrl.searchParams.get('q');
        _ttgMaps.metaParams.limit = $metaQueryUrl.searchParams.get('limit');
        _ttgMaps.metaParams.offset = $metaQueryUrl.searchParams.get('offset');
        _ttgMaps.metaParams.sort = $metaQueryUrl.searchParams.get('sort');
        _ttgMaps.metaParams.mkt = $metaQueryUrl.searchParams.get('mkt');
        _ttgMaps.metaParams.latitude = $metaQueryUrl.searchParams.get('latitude');
        _ttgMaps.metaParams.longitude = $metaQueryUrl.searchParams.get('longitude');
        _ttgMaps.metaParams.mode = $metaQueryUrl.searchParams.get('mode');
        if (_ttgMaps.metaParams.type === 'Event') {
            _ttgMaps.metaParams.startdate = $metaQueryUrl.searchParams.get('startdate');
            _ttgMaps.metaParams.enddate = $metaQueryUrl.searchParams.get('enddate');
            _ttgMaps.metaParams.unrollintervals = $metaQueryUrl.searchParams.get('unrollintervals');
        } else {
            if ($metaQueryUrl.searchParams.has('startdate')) {
                _ttgMaps.metaParams.startdate = $metaQueryUrl.searchParams.get('startdate');
            }
            if ($metaQueryUrl.searchParams.has('enddate')) {
                _ttgMaps.metaParams.enddate = $metaQueryUrl.searchParams.get('enddate');
            }
        }

        if ($metaQueryUrl.searchParams.has('occupation')) {
            _ttgMaps.metaParams.occupation = $metaQueryUrl.searchParams.get('occupation');
        }
        if (_ttgMaps.metaParams.sort === 'random') {
            if ($metaQueryUrl.searchParams.has('sortBy')) {
                _ttgMaps.metaParams.sortBy = $metaQueryUrl.searchParams.get('sortBy');
            }
            if ($metaQueryUrl.searchParams.has('sortByMeta')) {
                _ttgMaps.metaParams.sortByMeta = $metaQueryUrl.searchParams.get('sortByMeta');
            }
        }
        // wenn der API Endpunkt "hypersearch" ist, dann als sort=price übergeben werden, damit auch die hypersearch in D-Maps.js verwendet wird
        if ($metaQueryUrl.pathname === '/rest.ashx/hypersearch/') {
            _ttgMaps.metaParams.sort = 'price';
        }
        if ($metaQueryUrl.searchParams.has('filterstate')) {
            _ttgMaps.metaParams.filterstate = $metaQueryUrl.searchParams.get('filterstate');
        }
        if ($metaQueryUrl.searchParams.has('removeEmptyItems')) {
            _ttgMaps.metaParams.removeEmptyItems = $metaQueryUrl.searchParams.get('removeEmptyItems');
        }

        /* MAP OPTIONS */
        _ttgMaps.mapOptions.experience = _ttgMaps.metaParams.experience;
        _ttgMaps.mapOptions.container = "ttgInlineListMap";
        _ttgMaps.mapOptions.mapResized = false;
        _ttgMaps.mapOptions.layer = 0;

        console.log('TTGMaps Lizenz: ', $('#td').data('mapslicense'));

        /* NEW CONTENT IN MAP > Paging, Filtering, etc. */
        _ttgMaps.f.listMap.mapNewContent();

        /* INIT MAP */
        _ttgMaps.f.initMap();

        /* DRAW MAP CONTAINER */
        if ($('#' + _ttgMaps.mapOptions.container).length === 0) {
            let $ttgInlineListMap = $('<div />').prop('id', _ttgMaps.mapOptions.container).addClass('init');
            // .on('click', '.maps-close-btn', function() {
            //     ttgMap.hidePopup();
            //     // ttgMap.clearTour();
            //     // ttgMap.unselectAll();
            // });
            // $ttgInlineListMapWrapper.html($ttgInlineListMap).insertBefore($td.find('>.row'));

            _ttgMaps.f.loading($ttgInlineListMap);

            if (_ttgMaps.metaParams.type === 'Tour') {
                // let $elevationChart = $('<div />').prop('id', 'chart').addClass('chart');
                $ttgInlineListSelectedMapItem.html('<div id="chart" class="chart"></div>');

                // FULLSCREEN
                $ttgFullScreenInfoDiv.html('<div id="chartFullscreen" class="chart"></div>');

            }

            $ttgInlineListMap.append($ttgFullScreenInfoDiv);
            $ttgInlineListMapWrapper.append($ttgInlineListSelectedMapItem);
            $ttgInlineListMapWrapper.append($ttgInlineListMap);

            $ttgInlineListMapWrapper.insertAfter($td.find('#listOptions'));

            /* BIND FUNCTION ON MAP TRIGGER BUTTON */
            if (_ttgMaps.metaParams.type === 'Event') {
                $td.find('#listOptions .ttgKarteTab').on('click', _ttgMaps.f.listMap.showInlineListMap);
            } else {
                $td.find('#listOptions .optionKarte').on('click', _ttgMaps.f.listMap.showInlineListMap);
            }

        }

        /* BIND ENTRY MAP CLICK */
        $('#resultSet .entries').on('click', '.entry li.mapLink a', function(e) {
            e.preventDefault();
            let item = {
                id: $(this).data('sourceid')
            };
            _ttgMaps.f.listMap.showInlineListMap(item, $(this).closest('.entry'));
        });

    }

    // /* MAP SEARCH */
    // $("#ttgMaps_search .ttgMapsSearchField").keyup(function() {
    //     let inputField = $(this);
    //     setTimeout(function() {
    //         if ($(inputField).val().length > 2) {
    //             // Suchbegriff an q-Parameter übergeben und wieder loadListMap aufrufen?
    //         }
    //     }, 1500);
    // });

});

_ttgMaps.f.listMap = {

    /* CLEAR MAP */
    mapNewContent = function() {

        if (ttgMaps[0]) {
            if (Done.Maps.isSupported()) {
                // Sicherheitscheck: nicht aufrufen wenn ttgMaps[0] eine NCE-Karte ist (z.B. wenn karteAusblenden aktiv ist und die NCE-Karte ttgMaps[0] belegt)
                if (!$(ttgMaps[0].map._container).hasClass('nce-karte')) {
                    _ttgMaps.f.loadListMap();
                    _ttgMaps.f.listMap.topPagination('show');
                }
            }
        } else {
            return;
        }

    },

    /* SHOW MAP CONTAINER */
    showInlineListMap = function(selectItem, $entry) {

        _ttgMaps.f.listMap.topPagination('destroy');
        // $('#chart').hide();

        if (selectItem.id) {

            /* MAPS & PAGINATION ON ITEM CLICK ZEIGEN */
            $ttgInlineListMapWrapper.addClass('show');
            $td.find('#listOptions .optionKarte').addClass('show');

            if (_ttgMaps.metaParams.type === 'Event') {
                if (!$td.find('#listOptions .ttgKarteTab .hideMap').length) {
                    $td.find('#listOptions .ttgKarteTab').addClass('hideMap');
                    $td.find('#listOptions .ttgKarteTab span.fa-regular').addClass('fa-eye-slash').removeClass('fa-map');
                }
            } else {
                if (!$td.find('#listOptions .optionKarte .hideMap').length) {
                    $td.find('#listOptions .optionKarte').addClass('hideMap');
                    $td.find('#listOptions .optionKarte span.fa-regular').addClass('fa-eye-slash').removeClass('fa-map');
                }
            }

            _ttgMaps.f.selectMapItem(selectItem, $entry);
            _ttgMaps.f.listMap.topPagination('show');

            /* SCROLL " MAP "*/
            $ttgInlineListMapWrapper.animatescroll({
                padding: 150
            });

        } else {

            /* MAPS & PAGINATION ON CLICK ZEIGEN/VERBERGEN, je nachdem */
            if ($ttgInlineListMapWrapper.hasClass('show')) {

                $ttgInlineListMapWrapper.removeClass('show');
                if (_ttgMaps.metaParams.type === 'Event') {
                    $td.find('#listOptions .ttgKarteTab').removeClass('show');
                    $td.find('#listOptions .ttgKarteTab').removeClass('hideMap');
                    $td.find('#listOptions .ttgKarteTab span.fa-eye-slash').removeClass('fa-eye-slash').addClass('fa-map');
                } else {
                    $td.find('#listOptions .optionKarte').removeClass('show');
                    $td.find('#listOptions .optionKarte').removeClass('hideMap');
                    $td.find('#listOptions .optionKarte span.fa-eye-slash').removeClass('fa-eye-slash').addClass('fa-map');
                }
                // _ttgMaps.f.listMap.topPagination('destroy');

            } else {

                $ttgInlineListMapWrapper.addClass('show');
                if (_ttgMaps.metaParams.type === 'Event') {
                    if (!$td.find('#listOptions .ttgKarteTab .hideMap').length) {
                        $td.find('#listOptions .ttgKarteTab').addClass('hideMap');
                        $td.find('#listOptions .ttgKarteTab span.fa-regular').addClass('fa-eye-slash').removeClass('fa-map');
                    }
                } else {
                    if (!$td.find('#listOptions .optionKarte .hideMap').length) {
                        $td.find('#listOptions .optionKarte').addClass('hideMap');
                        $td.find('#listOptions .optionKarte span.fa-regular').addClass('fa-eye-slash').removeClass('fa-map');
                    }
                }
                _ttgMaps.f.listMap.topPagination('show');

            }

        }

        if ($('#' + _ttgMaps.mapOptions.container).hasClass('init')) {
            $.each(ttgMaps, function() {
                this.resize();
            });

            /* Hide Map on CountIndicator Click */
            $('#td #countIndicator').closest('div.wrapper').click(function(e) {
                _ttgMaps.f.listMap.topPagination('destroy');
                $ttgInlineListMapWrapper.removeClass('show');
                if (_ttgMaps.metaParams.type === 'Event') {
                    $td.find('#listOptions .ttgKarteTab').removeClass('show');
                    $td.find('#listOptions .ttgKarteTab').removeClass('hideMap');
                    $td.find('#listOptions .ttgKarteTab span.fa-eye-slash').removeClass('fa-eye-slash').addClass('fa-map');
                } else {
                    $td.find('#listOptions .optionKarte').removeClass('show');
                    $td.find('#listOptions .optionKarte').removeClass('hideMap');
                    $td.find('#listOptions .optionKarte span.fa-eye-slash').removeClass('fa-eye-slash').addClass('fa-map');
                }
            });

            $('#' + _ttgMaps.mapOptions.container).removeClass('init');

            // beim Terminal die Outgoing Links deaktivieren
            _ttgMaps.f.deactiveOutgoingLinks();
        }

    },

    visibleInMapListIndicator = function($entry) {
        $td.find('#resultSet .entries .entry.visibleInMap').removeClass('visibleInMap');
        $entry.addClass('visibleInMap');
    },

    /* ADD PAGINATION TO TOP */
    topPagination = function(mode) {

        try {
            switch (mode) {
                case 'show':
                    if (!$td.find('#resultSet nav.pagingTop').length) {
                        let $pagingMap = $td.find('#resultSet nav').clone(true);
                        $pagingMap.addClass('pagingTop mt-3')
                            .find('ul').removeClass('mt-0 mb-5 pull-right').addClass('m-0');

                        let $closeAndIndicator = $('<div />').addClass('closeAndIndicator'),
                            $indicator = $('<div />').addClass('indicator');
                        // $close = $('<a />').addClass('closeMapBtn')

                        let max = parseInt($('#countIndicator .count').text()),
                            von = parseInt(_ttgMaps.metaParams.offset) + 1,
                            bis = parseInt(_ttgMaps.metaParams.offset) + parseInt(_ttgMaps.metaParams.limit);
                        bis = (bis > max) ? max : bis;
                        $indicator.text(von + '-' + bis + ' von ' + max + ' Ergebnissen');

                        // $close.prop({
                        //     href: '#'
                        // }).html('<span class="fa-solid fa-xmark pr-2"></span><span class="text">Karte schließen</span>').click(_ttgMaps.f.listMap.showInlineListMap);

                        $closeAndIndicator
                            // .prepend($close)
                            .append($indicator)
                            .appendTo($pagingMap);

                        $pagingMap.appendTo($ttgInlineListMapWrapper);
                    }
                    break;
                case 'destroy':
                    $td.find('nav.pagingTop').remove();
                    break;
            }
        } catch (err) {

        }

    },

    resetListMap = function() {
        _ttgMaps.f.listMap.topPagination('destroy');

        $('#chart').removeClass('tourIsSelected').empty();
        $('#chartFullscreen').removeClass('tourIsSelected').empty();

        $('#' + _ttgMaps.mapOptions.container).removeClass('tourIsSelected');
        $('.selectedMapItemInfo').remove();

        $('#ttgFullScreenSelectedMapItem, #ttgInlineListSelectedMapItem').removeClass('selected');

        try {
            _ttgMaps.activePin.ttgInlineListMap.remove();
            _ttgMaps.elevationPin.remove();
        } catch (e) {}
    }

    /*
    _ttgMaps.f.mapSearchInBounds = function() {
        if (!ttgMap) {
            return;
        }
        // console.log(options);
    
        const bounds = ttgMap.getMap().getBounds(); // LngLatBounds
        let nw = bounds.getNorthWest();
        let se = bounds.getSouthEast();
    
        _ttgMaps.mapOptions.limitBounds = _ttgMaps.mapOptions.limitBounds + _ttgMaps.metaParams.limit;
        // _ttgMaps.mapOptions.limit = limitBounds;
        _ttgMaps.mapOptions.nwlatitude = nw.lat;
        _ttgMaps.mapOptions.nwlongitude = nw.lng;
        _ttgMaps.mapOptions.selatitude = se.lat;
        _ttgMaps.mapOptions.selongitude = se.lng;
        _ttgMaps.mapOptions.sort = '';
        _ttgMaps.mapOptions.offset = 0;
        _ttgMaps.metaOptions.sort = _ttgMaps.mapOptions.sort;
        _ttgMaps.metaOptions.offset = _ttgMaps.mapOptions.offset;
    
        // MapsDebug('Liste.js => _ttgMaps.f.mapSearchInBounds', 'mapOptions', options);
    
        window['mapLayer' + _ttgMaps.mapOptions.layer] = ttgMap.showContent(_ttgMaps.mapOptions);
        ttgMap.fitLayer(window['mapLayer' + _ttgMaps.mapOptions.layer]);
    
    };
    */

};